export const state = {
  group: null,
  groups: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/group/state.js